export default "__VITE_ASSET__opsiw3zn__"